import React, { Component } from 'react';

class Login extends Component {
    render() {
        return (
            <div>
                <h1>404 Page Not Found</h1>
            </div>
        );
    }
}

export default Login;


// WEBPACK FOOTER //
// ./src/components/Pages/Common/404/index.js